/** @deprecated using number formatters from the @validereinc/utilities pkg */
export function getFormattedNumber(number) {
  // transform number to more readable text
  // ie 100000 -> 100,000
  return number ? new Intl.NumberFormat().format(number) : number;
}

/** @deprecated using number formatters from the @validereinc/utilities pkg */
export const getFormattedNumberWithUnit = (object) => {
  if (object?.value || object?.value === 0) {
    return `${getFormattedNumber(object.value)} ${object.unit}`;
  }

  return "-";
};

/** @deprecated use data display components */
// duplicate of frontend-validere stringFormatter.js
export const displayValue = (value) => {
  if (value === true) {
    return "yes";
  }
  if (value === false) {
    return "no";
  }
  if (Array.isArray(value)) {
    return value.length === 0 ? "-" : value.join(", ");
  }
  return value ?? "-";
};
